
import { Scrollbar, Swiper } from "swiper";
import { PropType } from "vue";
import {v4 as uuid} from "uuid";
// import "swiper/scss";
// import "swiper/scss/pagination";

export default {
    props: {
        element: {
            type: Object as PropType<{ title: string, items: Array<{value: Array<{url: string}>}> }>,
        }
    },
    methods: {
        generateSwiperClass(key: number): string {
            return 'js-swiper-gallery-' + this.id + '-' + key
        },
        dataFancybox(key: number): string {
            return 'gallery-' + this.id + '-' + key;
        }
    },
    mounted() {
        this.$nextTick(function () {
            Swiper.use([Scrollbar]);

            this.element.items.forEach((item, index: number) => {
                new Swiper('.' + this.generateSwiperClass(index), {
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        hide: false
                    },
                    //height: 450,
                    loop: false,
                    spaceBetween: 15,
                    slidesPerView: 'auto',
                });
            });
        })
    },
    data() {
        return {
            id: uuid()
        }
    }
}
